let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i6fjC")).then(() => parcelRequire('Ux7bt'));